<template>
	<div class="w-100">
		<error></error>
            <form v-if="!isPasswordForgot" onsubmit="return false">
				<v-row><v-col>
					<c-input
						v-model="email"
						labelWidth="10%"
						:title="$t('text.email')"
						:error="errors.email"
						@validate="validateEmail"
						:disabled="loading"
						@keyup.enter.native="forgotPassword">
					</c-input>
				</v-col></v-row>
				<v-row><v-col>
					<c-button
						:disabled="loading || !validateForm()"
						@click="forgotPassword"
						:label="$t(`text.forgotPasswordButton`)">
					</c-button>
				</v-col></v-row>
            </form>

            <v-alert v-else type="success">
                {{ $t(`text.forgotPasswordSuccess`) }}
            </v-alert>

            <spinner :loading="loading"></spinner>
	</div>
</template>

<script>
import { mapActions } from 'vuex';

import authActions from '../store/actions/auth';
import errorActions from '../store/actions/error';
import namespace from '../store/namespace';

import Spinner from '../general/Spinner.vue';
import Error from '../general/Error.vue';

import CInput from '../globalComponents/CInput.vue';
import CButton from '../globalComponents/CButton.vue';

import modelState from '../mixins/modelState';
import rules from '../globalComponents/mixins/rules';

export default {
	name: 'ForgotPassword',
	mixins: [modelState, rules],
	components: {
		CButton,
		CInput,
		Spinner,
		Error,
	},
	mounted() {
		this.REMOVE_ERROR();
	},
	data() {
		return {
			email: '',
			confirmed: false,
			errors: {
				email: {},
			},
			modelState: {},
			loading: false,
		};
	},
	computed: {
		isPasswordForgot() {
			return this.confirmed;
		},
	},
	methods: {
		...mapActions(namespace.AUTH, [authActions.FORGOT_PASSWORD]),
		...mapActions(namespace.ERROR, [errorActions.REMOVE_ERROR]),
		async forgotPassword() {
			this.loading = true;

			if (this.validateForm()) {
				const forgotPassword = {
					email: this.email,
					confirmUrl: `${window.location.origin}/resetpassword`,
				};

				try {
					this.modelState = {};
					await this.FORGOT_PASSWORD(forgotPassword);

					this.confirmed = true;
				} catch (e) {
					console.log(e);
					this.modelState = e.response.data;
					if (this.modelError()) {
						throw new Error(this.modelError());
					}

					throw e;
				} finally {
					this.loading = false;
				}
			}
			this.loading = false;
		},
		apiErrors(propName) {
			const apiErrors = this.validateProperty(propName);

			if (apiErrors.length > 0) return { show: true, message: apiErrors };

			return {};
		},
		validateForm() {
			const val = Object.keys(this.errors);

			const ret = val.every((p) => {
				if (this.errors[p].show === true) {
					return false;
				}
				return true;
			});

			return ret;
		},
		validateEmail() {
			this.errors.email = {};
			if (this.isEmpty(this.email)) this.errors.email = { show: true, message: this.$i18n.t('text.errorEmailRequired') };
			else if (this.isInvalidEmail(this.email)) this.errors.email = { show: true, message: this.$i18n.t('text.errorInvalidEmail') };
			else this.errors.email = this.apiErrors('Email');
		},
	},
};
</script>


<style lang="scss" scoped>

@import "../globalComponents/style/_globals";

</style>
